import { NotificationTypes, VoyNotification } from "../services/types/vessel-notifications-services.types";
import { BaseModel } from "./base-model";
import { VoyagePlan } from "./vessel-planning-model";
//dummy commit
export interface IntermediatePlan
{
    id: number,
    plan_id: number,
    optimized_plan: VoyagePlan,
    created_at: string
}

export const EtaRequestDeactivated = {
    RequestFromTbm: 'This is deactivated, as you have ETA change request from TBM.',
    PilotPointPassed: 'This is deactivated, as vessel has passed the Arrival Pilot Station.',
    NeedApprovedPlan: 'This is deactivated, as you need an approved plan.'
}

export enum ScheduleChangeStates {
    Active = "Active",
    InProgress = "in-progress",
    Accepted = "accepted",
    Declined = "declined",
    Ended = "ended"
}

export type ReasonOption = string | { label: string; definition?: string }

export const ReasonsForDecliningOrRequestingNewEta: Record<string, ReasonOption> = {
  ACC: {
    label: "Accident involving personnel",
    definition: "Deviation for landing of injured / fatal or sick person",
  },
  DEV: {
    label: "Deviation of course to avoid Bad weather",
    definition: "Change of waypoints in passage plan due to weather and sea state",
  },
  EDD: {
    label: "Emergency Dry Docking",
    definition: "Unplanned, ad-hoc yardstay due to technical issue",
  },
  ENG: {
    label: "Engine Repairs",
    definition: "Malfunctioning of Main Engine, Auxilliary Engine or Auxilliary Systems",
  },
  SPE: {
    label: "Ship - personnel or equipment unavailable",
    definition: "Crew Rest hours",
  },
  VGR: {
    label: "Vessel Gear Breakdown",
    definition: "Breakdown of navigational, deck crane or life saving equipment",
  },
  OTV: {
    label: "Others - Vessel Related",
    definition:
      "Drifting, vessel ahead of schedule; Embarkation / disembarkation of armed guards; " +
      "Security incidents; Transit deviation for stores/spares/provisions; Arrival checks; " +
      "Grounding / Collision / Fire / heavy weather damage / docking delays" +
      "(Docking - network delay)" + 
      "(Docking - weather delay)",
  },
  ANA: {
    label: "Authorities not available",
    definition: "Waiting for Port Clearance / Agent",
  },
  PIT: {
    label: "Pilot / Tug not available",
    definition: "Waiting for pilotage / tugs",
  },
  QUV: {
    label: "Quarantine Vessel",
    definition: "Pandemic / health quarantine",
  },
  PTF: {
    label: "Port traffic restrictions",
    definition: "Traffic / Channel / Canal clearance",
  },
  RSC: {
    label: "Search and Rescue",
    definition: "Personal safety",
  },
  TID: {
    label: "Tidal restrictions",
    definition: "Tidal restriction",
  },
  VIN: {
    label: "Vessel inspections by Coast Guard",
    definition: 
    "Inspection by authorities (Coast Guard)" +
    "Port / Terminal related - inspection by authorities (non-technical)",
  },
  WEA: {
    label: "Deviation of speed to avoid Bad Weather",
    definition: "Bad weather impacting vessel’s speed (no change of waypoint – see DEV)",
  },
};
export interface DeclineClf
{
    reason: string;
    reasonCode: string;
    comment: string;
    bestEtaTime?: string | undefined;
}

export abstract class ScheduleChangeModelBase extends BaseModel {
    abstract checkEtaChangeAlerts(alert: ScheduleEtaChangeType): void;
    abstract getNewPlanWithUpdatedEta(): Promise<IntermediatePlan | null>;
    abstract updateNewPlanWithUpdatedEta(plan: VoyagePlan): Promise<VoyagePlan | null>;
    abstract checkForDeclinedRequest(alert?: ScheduleEtaChangeType): Promise<ScheduleEtaChangeType | undefined>
    abstract checkIfOptimizationFailed(): Promise<boolean>;
    abstract getCurrentAlert(): ScheduleEtaChangeType | null;
    abstract postStateChangeAlert(notificationId: string, state: string, data: any): Promise<void>;
    abstract getLatestAlert(): Promise<ScheduleEtaChangeType>;
    abstract postEtaRequestAlert(data: any): Promise<void>;
    abstract getEtaRequestAlert(): Promise<RequestEtaChangeType | null>;
}

export type ScheduleEtaChangeType = VoyNotification<NotificationTypes.ScheduledETAChange>;
export type RequestEtaChangeType = VoyNotification<NotificationTypes.RequestETAChange>;

let ScheduleChangeModel: ScheduleChangeModelBase|null = null;

function setScheduleChangeModel(model: ScheduleChangeModelBase){
    ScheduleChangeModel = model;
}

export { ScheduleChangeModel, setScheduleChangeModel };